angular.module('Mineler').run(['$templateCache', function($templateCache) {
  $templateCache.put('map/panels/experience/experience-edit.tpl.html',
    '<div id="map-panel-experience-add-action" class="map-secondary-panel"\n' +
    '     ng-controller="ExperienceEditCtrl as experienceEdit" ng-swipe-left="experienceEdit.closePanel()" ng-swipe-disable-mouse>\n' +
    '  <div class="row map-panel-heading">\n' +
    '    <div class="small-2 columns">\n' +
    '      <a class="arrow-back" ng-click="experienceEdit.closePanel()">\n' +
    '        <i class="fa fa-angle-double-left"></i>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '    <div class="small-13 columns">\n' +
    '      <h3>Edit Experience</h3>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="experience-form-container">\n' +
    '    <div class="row">\n' +
    '      <div class="small-15 columns">\n' +
    '        <form name="editExperienceForm" role="editExperienceForm">\n' +
    '          <div class="row">\n' +
    '            <div class="small-15 columns">\n' +
    '              <select name="idProject" ng-model="experienceEdit.data.idProject">\n' +
    '                <option value="0">SELECT PROJECT OR ADD NEW</option>\n' +
    '                <option ng-repeat="project in experienceEdit.projects" ng-value="project.id"\n' +
    '                        ng-selected="project.id == experienceEdit.data.idProject">\n' +
    '                  {{project.name}}\n' +
    '                </option>\n' +
    '                <option value="-1">ADD NEW</option>\n' +
    '              </select>\n' +
    '              <input ng-if="experienceEdit.data.idProject == -1" type="text" name="projectName"\n' +
    '                     ng-model="experienceEdit.data.projectName" ng-required="true" placeholder="PROJECT NAME" />\n' +
    '\n' +
    '            </div>\n' +
    '            <div class="small-15 columns">\n' +
    '              <small class="request-validation-error">\n' +
    '                {{experienceEdit.errors.projectError}}\n' +
    '              </small>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="row">\n' +
    '            <div class="small-15 columns">\n' +
    '              <angucomplete-alt\n' +
    '                id="experience-company-input"\n' +
    '                placeholder="SELECT COMPANY OR ADD NEW"\n' +
    '                pause="100"\n' +
    '                minlength="2"\n' +
    '                remote-url="{{experienceEdit.searchCompanyUrl}}"\n' +
    '                title-field="companyName"\n' +
    '                remote-url-response-formatter="experienceEdit.onSearchResponse"\n' +
    '                text-searching="SEARCHING ..."\n' +
    '                selected-object="experienceEdit.onCompanySearchSelect"\n' +
    '                match-class="text-orange"\n' +
    '                text-no-results=" "\n' +
    '                override-suggestions="true"\n' +
    '                input-changed="experienceEdit.onCompanyChanged"\n' +
    '                initial-value="{{experienceEdit.data.employerName}}"\n' +
    '                focus-in="experienceEdit.onFocusCompany()"\n' +
    '                />\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="small-15 columns">\n' +
    '              <small class="request-validation-error" ng-show="experienceEdit.errors.employerError">\n' +
    '                {{experienceEdit.errors.employerError}}\n' +
    '              </small>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="row">\n' +
    '            <div class="small-15 columns">\n' +
    '              <angucomplete-alt\n' +
    '                id="experience-position-input"\n' +
    '                placeholder="SELECT POSITION OR ADD NEW"\n' +
    '                pause="100"\n' +
    '                minlength="2"\n' +
    '                remote-url="{{experienceEdit.searchPositionUrl}}"\n' +
    '                title-field="name"\n' +
    '                remote-url-response-formatter="experienceEdit.onSearchResponse"\n' +
    '                text-searching="SEARCHING ..."\n' +
    '                selected-object="experienceEdit.onPositionSearchSelect"\n' +
    '                match-class="text-orange"\n' +
    '                text-no-results=" "\n' +
    '                override-suggestions="true"\n' +
    '                input-changed="experienceEdit.onPositionChanged"\n' +
    '                initial-value="{{experienceEdit.data.jobTitleName}}"\n' +
    '                focus-in="experienceEdit.onFocusJobTitle()"\n' +
    '                />\n' +
    '\n' +
    '            </div>\n' +
    '            <div class="small-15 columns">\n' +
    '              <small class="request-validation-error" ng-show="experienceEdit.errors.jobTitleError">\n' +
    '                {{experienceEdit.errors.jobTitleError}}\n' +
    '              </small>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="row experience-date-picker-container">\n' +
    '            <div class="small-2 columns">FROM</div>\n' +
    '            <date-picker ng-model="experienceEdit.data.dateFrom"></date-picker>\n' +
    '\n' +
    '            <div class="small-15 columns">\n' +
    '              <small class="request-validation-error" ng-show="experienceEdit.errors.dateFromError">\n' +
    '                {{experienceEdit.errors.dateFromError}}\n' +
    '              </small>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="row" ng-hide="experienceEdit.data.isCurrentExperience">\n' +
    '            <div class="small-2 columns">TO</div>\n' +
    '            <date-picker ng-model="experienceEdit.data.dateTo"></date-picker>\n' +
    '            <div class="small-15 columns">\n' +
    '              <small class="request-validation-error" ng-show="experienceEdit.errors.dateToError">\n' +
    '                {{experienceEdit.errors.dateToError}}\n' +
    '              </small>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="row">\n' +
    '            <div class="small-15 columns">\n' +
    '              <input type="checkbox" id="isCurrentExperience" name="isCurrentExperience" ng-model="experienceEdit.data.isCurrentExperience" />\n' +
    '              <label for="isCurrentExperience">Currently working here</label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="row">\n' +
    '            <div class="small-15 columns">\n' +
    '              <textarea name="description" ng-model="experienceEdit.data.description" msd-elastic\n' +
    '                        placeholder="ADD DESCRIPTION OF WORK"></textarea>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="row">\n' +
    '            <div class="small-15 columns">\n' +
    '              <tags-input\n' +
    '                ng-model="experienceEdit.data.skills"\n' +
    '                add-on-enter="true"\n' +
    '                placeholder="ADD A SKILL"\n' +
    '                display-property="name"\n' +
    '                replace-spaces-with-dashes="false"\n' +
    '                >\n' +
    '                <auto-complete source="experienceEdit.loadSkills($query)" min-length="2"></auto-complete>\n' +
    '              </tags-input>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="row" ng-if="experienceEdit.data.validationsCounter > 0 && experienceEdit.hasDataChanged">\n' +
    '            <div class="small-15 columns">\n' +
    '              <h4>What would you like to do with existing validations?</h4>\n' +
    '            </div>\n' +
    '            <div class="small-15 columns">\n' +
    '              <label>\n' +
    '                <input type="radio" name="validationsAction" ng-model="experienceEdit.data.validationsAction" value="delete" /> DELETE\n' +
    '              </label>\n' +
    '              <label>\n' +
    '              <input type="radio" name="validationsAction" ng-model="experienceEdit.data.validationsAction" value="invalidate_resend" /> RE-SEND\n' +
    '              </label>\n' +
    '            </div>\n' +
    '            <div class="small-15 columns">\n' +
    '              <small class="request-validation-error" ng-show="experienceEdit.errors.validationsAction">\n' +
    '                {{experienceEdit.errors.validationsAction}}\n' +
    '              </small>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="row experience-form-buttons">\n' +
    '            <div class="small-10 columns">\n' +
    '              <small class="request-validation-error" ng-show="experienceEdit.errorMessage"\n' +
    '                     ng-bind-html="experienceEdit.errorMessage"></small>\n' +
    '            </div>\n' +
    '            <div class="small-5 columns text-right">\n' +
    '              <span us-spinner="{radius:3, width:3, length: 8, color: \'#ffffff\'}" spinner-key="spinner-experience-add"></span>\n' +
    '              <button class="button positive" ng-hide="experienceEdit.isAdding"\n' +
    '                      ng-disabled="editExperienceForm.$invalid"\n' +
    '                      ng-click="experienceEdit.save()">\n' +
    '                SAVE\n' +
    '              </button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </form>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);
